var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIssueicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2887_10520)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 0.748047,
    width: 58,
    height: 58,
    rx: 8,
    fill: "#346F98"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 0.748047,
    width: 58,
    height: 58,
    rx: 8,
    fill: "url(#paint0_linear_2887_10520)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9577 34.5811C25.3 34.5811 25.587 34.4653 25.8186 34.2337C26.0502 34.0021 26.166 33.7151 26.166 33.3727C26.166 33.0304 26.0502 32.7434 25.8186 32.5118C25.587 32.2802 25.3 32.1644 24.9577 32.1644C24.6153 32.1644 24.3283 32.2802 24.0967 32.5118C23.8651 32.7434 23.7493 33.0304 23.7493 33.3727C23.7493 33.7151 23.8651 34.0021 24.0967 34.2337C24.3283 34.4653 24.6153 34.5811 24.9577 34.5811ZM23.7493 30.9561H26.166V24.9144H23.7493V30.9561ZM28.5827 33.3727H38.2493V30.9561H28.5827V33.3727ZM28.5827 28.5394H38.2493V26.1227H28.5827V28.5394ZM21.3327 39.4144C20.6681 39.4144 20.0992 39.1778 19.6259 38.7045C19.1526 38.2312 18.916 37.6623 18.916 36.9977V22.4977C18.916 21.8331 19.1526 21.2642 19.6259 20.791C20.0992 20.3177 20.6681 20.0811 21.3327 20.0811H40.666C41.3306 20.0811 41.8995 20.3177 42.3728 20.791C42.846 21.2642 43.0827 21.8331 43.0827 22.4977V36.9977C43.0827 37.6623 42.846 38.2312 42.3728 38.7045C41.8995 39.1778 41.3306 39.4144 40.666 39.4144H21.3327Z",
    fill: "#E9E9E9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2887_10520",
    x: 0.791667,
    y: 0.748047,
    width: 60.4167,
    height: 60.4167,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.20833
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.604167
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2887_10520"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2887_10520",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2887_10520",
    x1: 31,
    y1: 0.748047,
    x2: 31,
    y2: 58.748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007DD6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIssueicon);
export default __webpack_public_path__ + "static/media/issue+icon.3b4f2193cd9832790dae2d12cc2e2fd8.svg";
export { ForwardRef as ReactComponent };